var map = {
	"./banner-1-01-01.png": "/xXI",
	"./banner-1.png": "/Y8n",
	"./banner-18-sept-belanda.png": "dGMg",
	"./banner-18-sept-inggris.png": "KfvL",
	"./banner-18-sept-itali.png": "tA1X",
	"./banner-18-sept-jepang.png": "vRxY",
	"./banner-18-sept-jerman.png": "xYp7",
	"./banner-18-sept-perancis.png": "McJN",
	"./banner-191106-winter-sale.png": "R0ZJ",
	"./banner-191202-honeymoon.png": "/v3a",
	"./banner-2.png": "LEDK",
	"./banner-200120-cny.png": "qUYT",
	"./banner-3.png": "Nz4X",
	"./banner-4.png": "zd6A",
	"./banner-5.png": "qDXl",
	"./banner-6.png": "0qnD",
	"./banner-aug-1.png": "z4Fi",
	"./banner-aug-17.png": "4IFy",
	"./banner-corona.png": "ilau",
	"./banner-sept-10.png": "p8t+",
	"./banner-sumpah-pemuda.png": "E/8X",
	"./sample.png": "Jnl4"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "TDsS";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners ^\.\/.*$
// module id = TDsS
// module chunks = 1